import _ from "lodash";
import client from "lib/apolloClient/client";

import {
  getIncidentDetailsQuery,
  getStudentListQuery,
  getStudentDetailsQuery,
  getActivityLogQuery,
} from "./IncidentQueries";
import { studentFragment } from "./IncidentFragments";

export const getIncidentDetailsFromCache = variables => {
  try {
    const queryData = client.readQuery(
      {
        query: getIncidentDetailsQuery,
        variables,
      },
      true
    );
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeIncidentDetailsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getIncidentDetailsQuery,
      variables,
      data,
    });
  } catch (e) {}
};

export const getStudentListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentListQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentDetailsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentDetailsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentFamiliesFromCache = ({ studentId, variables }) => {
  try {
    return client.readFragment({
      id: `Student:${studentId}`,
      fragment: studentFragment.studentFamiliesFragment,
      fragmentName: "studentFamilies",
      variables,
    });
  } catch (e) {
    return {};
  }
};

export const getStudentHomeroomAdvisorFromCache = ({
  studentId,
  staffRelationFilters,
}) => {
  try {
    return client.readFragment({
      id: `Student:${studentId}`,
      fragment: studentFragment.studentHomeroomAdvisorFragment,
      fragmentName: "studentHomeroomAdvisor",
      variables: { staffRelationFilters },
    });
  } catch (e) {
    return {};
  }
};

export const getActivityLogFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getActivityLogQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
